// bao migrate skip
import "./tooltip.css";
import "./../../bindings/element";
import * as ko from "knockout";
import * as $ from "jquery";
export interface TooltipParams {
    /**
    * optional: 'top' or 'bottom' placement - default: bottom
    **/
    mode?: string;
    loaded?: (pager: BaoTooltip) => void;
    /**
    * optional: is used to load html asynchronous and pass it to the tooltip component
    **/
    asyncLoad?: () => JQueryPromise<string>;
    /**
    * optional: if set, then asyncLoad moded will be handled and a img thumbnail added dynamically
    **/
    imageUrl?: KnockoutObservable<string> | string;
    /**
     * optional: if set, the the text will be displayed below the img
     * */
    description?: KnockoutObservable<string> | string;
}
export class BaoTooltip {
    constructor(params: TooltipParams, element: HTMLElement, innerHtml: HTMLElement[]) {
        if (params != null) {
            if (params.loaded != null) {
                setTimeout(() => {
                    params.loaded(this);
                }, 1);
            }
            this.Mode = params.mode;
            if (params.imageUrl != null) {
                if (ko.isObservable(params.imageUrl)) {
                    this.ImageUrl = params.imageUrl;
                }
                else {
                    this.ImageUrl(ko.unwrap(params.imageUrl));
                }
            }
        }
        if (this.Mode == null) {
            this.Mode = "bottom";
        }
        if (innerHtml != null && innerHtml.length > 0) {
            ko.utils.arrayForEach(innerHtml, (node) => {
                let parentNode = node.parentNode;
                if (parentNode != null) {
                    parentNode.removeChild(node);
                }
            });
        }
        this._subs.push(this.InnerHtmlElement.subscribe(() => {
            ko.utils.arrayForEach(innerHtml, (node) => {
                this.InnerHtmlElement().appendChild(node);
            });
        }));
        if (params.description != null) {
            if (ko.isObservable(params.description)) {
                this.Description = params.description;
            }
            else {
                this.Description = ko.observable<string>(params.description);
            }
        }
        else {
            this.Description = ko.observable<string>("");
        }
        this.DescriptionVisible = ko.pureComputed(() => {
            return this.Description() != null && this.Description() != "";
        });
        this.Container = element;
        this.Init();
    }
    public InnerHtmlElement = ko.observable<HTMLElement>();
    public ImageUrl = ko.observable<string>();
    public Description: KnockoutObservable<string>;
    public DescriptionVisible: KnockoutComputed<boolean>;
    private Container: HTMLElement;
    private _subs: KnockoutSubscription[] = [];
    private Mode: string;
    private TargetElement: HTMLElement;
    private AsyncLoad: () => JQueryPromise<string>;
    private AsyncLoaded = false;
    private AsyncImageLoad() {
        let def = $.Deferred<string>();
        def.resolve("<img class='img-thumbnail' src='" + this.ImageUrl() + "' />");
        return def.promise();
    }
    private Init() {
        $(this.Container).addClass("tooltip").addClass(this.Mode);
        switch (this.Mode) {
            case "bottom":
                this.TargetElement = <HTMLElement>this.Container.previousElementSibling;
                break;
            case "top":
                this.TargetElement = <HTMLElement>this.Container.nextElementSibling;
                break;
        }
        $(this.TargetElement).hover(this.HoverIn as any, this.HoverOut as any);
    }
    private HoverIn = (e: JQueryEventObject) => {
        this.Show();
    };
    private HoverOut = (e: JQueryEventObject) => {
        this.Hide();
    };
    Show() {
        var linkProps = $(this.TargetElement).position();
        var padding = 5;
        switch (this.Mode) {
            case "bottom":
                this.Container.setAttribute('style', 'top:' + (linkProps.top + $(this.TargetElement).height()) + 'px;' + 'left:' + linkProps.left + 'px;');
                break;
            case "top":
                this.Container.setAttribute('style', 'top:' + (linkProps.top - $(this.Container).height() - padding) + 'px;' + 'left:' + linkProps.left + 'px;');
                break;
        }
        $(this.Container).addClass("tooltip-visible");
        if (this.ImageUrl() != null) {
            this.AsyncLoad = this.AsyncImageLoad;
        }
        if (this.AsyncLoad != null && this.AsyncLoaded == false) {
            $(this.InnerHtmlElement()).html("");
            this.AsyncLoad().then((innerHtml) => {
                this.AsyncLoaded = true;
                $(this.InnerHtmlElement()).html(innerHtml);
            });
        }
    }
    Hide() {
        $(this.Container).removeClass("tooltip-visible");
    }
    public dispose() {
        if (this._subs != null && this._subs.length > 0) {
            ko.utils.arrayForEach(this._subs, (s) => {
                s.dispose();
            });
        }
    }
}